import { AwningOutlineIcon } from './AwningOutlineIcon';

/**
 * author: Jeff Anders
 * id D2598CD1-6354-4499-9E67-EEF50D9B5226
 * name awning-outline
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/awning-outline.svg
 * tags
 * - Home Automation 
 */
export const SunShadeOutlineIcon = AwningOutlineIcon;
export default SunShadeOutlineIcon